<div class="masquerade-banner" *ngIf="isActive" role="alert" aria-live="polite">
    <div class="container-fluid">
        <div class="d-flex align-items-center justify-content-end h-100">
            <div class="d-flex align-items-center">
                <i class="bx bxs-mask me-2" aria-hidden="true"></i>
                <div class="masquerade-info me-3">
                    <span class="masquerade-label">Impersonating</span>
                    <span class="masquerade-role"
                        >[{{ masqueradedRole$ | async }}]</span
                    >
                    <span class="masquerade-name"
                        >[{{ masqueradedUserName$ | async }}]</span
                    >
                </div>
                <button
                    class="btn btn-light btn-sm"
                    (click)="stopMasquerade()"
                    [disabled]="isLoading"
                    aria-label="Stop impersonating user">
                    <i
                        *ngIf="isLoading"
                        class="bx bx-loader-alt bx-spin me-1"
                        aria-hidden="true"></i>
                    <span>Stop Impersonating</span>
                </button>
            </div>
        </div>
    </div>
</div>
